export default "__VITE_ASSET__B5tB6IuW__"